// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"727ec5bd","641":"61811576"}[chunkId] + ".chunk.js";
};